const getTp53Germline = (state) =>
  state.variantResult &&
  state.variantResult.iarc_tp53_germline &&
  state.variantResult.iarc_tp53_germline[0];

const getTp53GermlineSchema = (state) =>
  state.schema &&
  state.schema.properties &&
  state.schema.properties.iarc_tp53_germline;

const getTp53GermlineItems = (state) =>
  state.variantResult && state.variantResult.iarc_tp53_germline;

const getTp53Somatic = (state) =>
  state.variantResult &&
  state.variantResult.iarc_tp53_somatic &&
  state.variantResult.iarc_tp53_somatic[0];

const getTp53SomaticSchema = (state) =>
  state.schema &&
  state.schema.properties &&
  state.schema.properties.iarc_tp53_somatic;

const getTp53SomaticItems = (state) =>
  state.variantResult && state.variantResult.iarc_tp53_somatic;

export {
  getTp53Germline,
  getTp53Somatic,
  getTp53SomaticSchema,
  getTp53SomaticItems,
  getTp53GermlineSchema,
  getTp53GermlineItems,
};
